import { useCallback, useRef, useState } from 'react';
import { getText } from 'i18n/intl';
import { Input, Modal } from '@timeedit/ui-components/antd';
import type { InputRef } from '@timeedit/ui-components/antd';

const intlPrefix = 'integration.calendar.sync_settings';

export type StaticTextModalProps = {
  open: boolean;
  onOk: (text: string) => void;
  onCancel: () => void;
};

const StaticTextModal = ({ open, onOk, onCancel }: StaticTextModalProps) => {
  const inputRef = useRef<InputRef>(null);
  const [value, setValue] = useState('');

  const isValid = value.length > 0;

  const handleOk = useCallback(() => {
    if (!isValid) return;
    onOk(value);
    setValue('');
  }, [onOk, value, isValid]);

  const handleCancel = useCallback(() => {
    setValue('');
    onCancel();
  }, [onCancel]);

  return (
    <Modal
      title={getText(
        `${intlPrefix}.form.sync_mode.te_out.subject.static_text_modal.title`
      )}
      open={open}
      afterOpenChange={(isOpen) => {
        if (isOpen) {
          inputRef.current?.focus();
        }
      }}
      onOk={handleOk}
      okButtonProps={{ disabled: !isValid }}
      onCancel={handleCancel}
    >
      <Input
        ref={inputRef}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onPressEnter={handleOk}
      />
    </Modal>
  );
};

export default StaticTextModal;
